// Tryb — the studio context object and its hook.
//
// Kept apart from StudioProvider so that file exports only a component: Vite's
// Fast Refresh bails on a module that mixes components with other exports, and
// a full reload mid-edit throws away whatever the facilitator was typing.

import { createContext, useContext } from "react";

export const StudioContext = createContext(null);

export function useStudio() {
  const ctx = useContext(StudioContext);
  if (!ctx) throw new Error("useStudio must be used inside a StudioProvider");
  return ctx;
}
